/* global window */

import createModal from './create-modal';
import openModal from './open-modal';

export default function(rootElement) {
  if (!rootElement) {
    return;
  }

  createModal(rootElement);

  window.sdc = window.sdc || {};
  window.sdc.openModal = openModal;
}
